var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tabs-wrapper"
  }, [_c('ul', {
    staticClass: "tabs",
    class: {
      'tabs_boxed': _vm.boxed
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('li', {
      key: item.id,
      staticClass: "tab",
      class: {
        'tab_active': item.id === _vm.value,
        'tab_disabled': item.disabled,
        'tab_boxed': _vm.boxed
      }
    }, [_c('button', {
      staticClass: "tab__content",
      attrs: {
        "disabled": item.disabled
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('input', item.id);
        }
      }
    }, [_c(item.icon, {
      tag: "component",
      staticClass: "tab__icon"
    }), _c('span', {
      staticClass: "tab__text"
    }, [_vm._v(_vm._s(item.text))])], 1)]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }